import { render, staticRenderFns } from "./EditorQn3.vue?vue&type=template&id=6e872a20&scoped=true&"
import script from "./EditorQn3.vue?vue&type=script&lang=js&"
export * from "./EditorQn3.vue?vue&type=script&lang=js&"
import style0 from "./EditorQn3.vue?vue&type=style&index=0&id=6e872a20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e872a20",
  null
  
)

export default component.exports